const SESSION_DEATH_CODES = new Set([
	'auth_credentials_missing',
	'auth_jwt_invalid',
	'session_invalid',
	'session_expired',
	'user_deleted'
])

export function isSessionDeathCode(code: string | undefined) {
	return code !== undefined && SESSION_DEATH_CODES.has(code)
}
